export class SelectionHelper {
  static clearSelection() {
    window.getSelection().removeAllRanges();
  }
}
